import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ImpressumPage from '../pages/impressum/page';
import PrivacyPage from '../pages/privacy/page';
import WohnungsvermietungPage from '../pages/wohnungsvermietung/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/impressum',
    element: <ImpressumPage />,
  },
  {
    path: '/datenschutz',
    element: <PrivacyPage />,
  },
  {
    path: '/wohnungsvermietung',
    element: <WohnungsvermietungPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
